import { render, staticRenderFns } from "./_item.vue?vue&type=template&id=e718a0d4&"
import script from "./_item.vue?vue&type=script&lang=js&"
export * from "./_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports